import { h } from "omi";

import { IconProps } from "@/components";

export function MessageTextSquareIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M4.66667 5.66667H8M4.66667 8H10m-3.54417 4H10.8c1.1201 0 1.6802 0 2.108-.218.3763-.1917.6823-.4977.874-.874C14 10.4802 14 9.9201 14 8.8V5.2c0-1.12011 0-1.68016-.218-2.10798-.1917-.37633-.4977-.68229-.874-.87403C12.4802 2 11.9201 2 10.8 2H5.2c-1.1201 0-1.68016 0-2.10798.21799a1.999861 1.999861 0 0 0-.87403.87403C2 3.51984 2 4.0799 2 5.2v8.357c0 .3552 0 .5328.07282.6241.06333.0793.15936.1255.26087.1254.11673-.0002.25542-.1111.53281-.333l1.59031-1.2723c.32487-.2599.4873-.3898.66818-.4822.16048-.082.33129-.1419.50782-.1782C5.83178 12 6.0398 12 6.45583 12Z"
      />
    </svg>
  );
}
